import {
  convertTimeToInteger,
  dowStringToIndexArray,
} from "@outschool/business-rules/dist-cjs/Search";
import {
  ActivityListing_ListingFragment,
  ClassDetailsNoSectionsQuery,
  ClassDetailsQuery_SectionFragment,
  ListingCard_ListingFragment,
  SearchFilters,
} from "@outschool/gql-frontend-generated";
import { dayjs } from "@outschool/time";

import { filterToDayjs } from "../Search";

export const getActivityUpsellListing = (
  listings: (ActivityListing_ListingFragment | ListingCard_ListingFragment)[],
  currentActivity:
    | ClassDetailsNoSectionsQuery["activity"]
    | { uid?: string; upsell_activity_uid?: string | null }
):
  | ActivityListing_ListingFragment
  | ListingCard_ListingFragment
  | undefined => {
  const hasUpsellListing = listings?.length
    ? listings[0]?.activity.uid === currentActivity.upsell_activity_uid
    : false;

  const upsellListing = hasUpsellListing ? listings[0] : undefined;

  if (upsellListing && upsellListing.activity.uid !== currentActivity.uid) {
    return upsellListing;
  }

  return undefined;
};

export const MAIN_IMAGE_HEIGHT = 179;
export const MAIN_IMAGE_WIDTH = 344;
export function getFilteredSectionData({
  sectionData,
  filters,
  activity,
}: {
  sectionData: ClassDetailsQuery_SectionFragment[];
  filters?: SearchFilters;
  activity: any;
}) {
  let filteredSections = sectionData;
  filteredSections = filteredSections.filter(section => section.isBuyable);
  if (!filters) {
    return filteredSections;
  }

  if (!!filters.startAfter) {
    const { startDayjs, endDayjs } = filterToDayjs(
      filters.startAfter,
      filters.startBefore || null
    );
    if (activity.is_ongoing_weekly) {
      //filter out ongoing sections whos next meeting do not match the date filters
      if (startDayjs) {
        filteredSections = filteredSections.filter(
          section => dayjs(section.nextOngoingMeeting?.start_time) >= startDayjs
        );
      }
      if (endDayjs) {
        filteredSections = filteredSections.filter(
          section => dayjs(section.nextOngoingMeeting?.start_time) <= endDayjs
        );
      }
    } else {
      //filter out classes that start on a date that do not match the date filters
      if (startDayjs) {
        filteredSections = filteredSections.filter(
          section => dayjs(section.start_time) >= startDayjs
        );
      }
      if (endDayjs) {
        filteredSections = filteredSections.filter(
          section => dayjs(section.start_time) <= endDayjs
        );
      }
    }
  }

  //filter out sections that do not match at least one day of the dow filter
  if (!!filters?.dow) {
    const daysOfWeek = dowStringToIndexArray(filters?.dow);
    filteredSections = filteredSections.filter(section =>
      section.meetingTimes
        .map(meeting => {
          return meeting.dayOfWeek;
        })
        .some(day => daysOfWeek.includes(day))
    );
  }

  //filter out sections that start earlier than the startAfter filter time
  if (!!filters?.startAfterTime) {
    filteredSections = filteredSections.filter(
      section =>
        Number(
          convertTimeToInteger(dayjs(section.start_time).format("HH:mm"))
        ) >= filters?.startAfterTime!
    );
  }

  //filter out sections that end later than the endBy filter time
  if (!!filters?.endByTime) {
    filteredSections = filteredSections.filter(
      section =>
        Number(convertTimeToInteger(dayjs(section.end_time).format("HH:mm"))) <=
        filters?.endByTime!
    );
  }

  return filteredSections;
}
